import { injectReducer } from '../../store/reducers'
import { getListPatient, getListAppointment, openPage, clearList } from './modules/patients'

export default (store) => ({
  path : '',
  onEnter: function() {
      store.dispatch(clearList());
  },
  childRoutes: [
  ],
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Patients = require('./containers/PatientsContainer').default
      const reducer = require('./modules/patients').default
      injectReducer(store, { key: 'patients', reducer })
      store.dispatch(getListPatient());
      store.dispatch(getListAppointment());
      // store.dispatch(openPage());
      cb(null, Patients)
    }, 'patients')
  }
})



// WEBPACK FOOTER //
// ./src/routes/PatientDatabase/index.js